export const columns = [
  {
    title: "MAC地址",
    dataIndex: "macAddress",
    key: "macAddress",
  },
  {
    title: "面单尺寸",
    dataIndex: "size",
    key: "size",
    width:120,
    customRender: (text, record, index) => {
      return `${record.printPaperSizeWide}*${record.printPaperSizeHigh}`;
    },
  },
  {
    title: "打印机",
    dataIndex: "printer",
    key: "printer",
    width: 300,
  },
  {
    title: "方向",
    dataIndex: "direction",
    key: "direction",
    width:120,
    customRender: (text, record, index) => {
      return text == "1" ? "纵向" : "横向";
    },
  },
  {
    title: "状态",
    dataIndex: "isOpen",
    key: "isOpen",
    width:120,
    customRender: (text, record, index) => {
      return text ? "开启" : "关闭";
    },
  },
  {
    title: "创建人",
    dataIndex: "creatorName",
    key: "creatorName",
    width:120,
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const columns_pkg = [
  {
    title: "环节",
    dataIndex: "nodeName",
    key: "nodeName",
  },
  {
    title: "业务类型",
    dataIndex: "systemSource",
    key: "systemSource",
    width: 90,
    customRender: (text, record, index) => {
      return text == "1" ? "D2C" : "B2B";
    },
  },
  {
    title: "MAC地址",
    dataIndex: "macAddress",
    key: "macAddress",
  },
  {
    title: "打印纸尺寸",
    dataIndex: "size",
    key: "size",
    width:120,
    customRender: (text, record, index) => {
      return `${record.printPaperSizeWide}*${record.printPaperSizeHigh}`;
    },
  },
  {
    title: "打印机",
    dataIndex: "printer",
    key: "printer",
    width: 300,
  },
  {
    title: "方向",
    dataIndex: "direction",
    key: "direction",
    width:120,
    customRender: (text, record, index) => {
      return text == "1" ? "纵向" : "横向";
    },
  },
  {
    title: "状态",
    dataIndex: "isOpen",
    key: "isOpen",
    width:120,
    customRender: (text, record, index) => {
      return text ? "开启" : "关闭";
    },
  },
  {
    title: "创建人",
    dataIndex: "creatorName",
    key: "creatorName",
    width:120,
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const sheetSizeList = [
  {
    width: 70,
    height: 30,
  },
  {
    width: 100,
    height: 100,
  },
  {
    width: 100,
    height: 150,
  },
  {
    width: 150,
    height: 100,
  },
  {
    width: 107,
    height: 177,
  },
  {
    width: 108,
    height: 160,
  },
];
